import { WidgetFacetRange } from "~/bff/types/WidgetFacetRange";
import { WidgetFacetRangeValue } from "~/bff/types/WidgetFacetRangeValue";
import { isStoreOnlyDropdownQuery } from "~/components/products-layout/components/products-filters/components/filter/components/shop-filter/helpers/is-store-only-dropdown-query";
import { Filters } from "~/components/products-layout/components/products-filters/types";
import { DEFAULT_PAGE_SIZE } from "~/components/products-layout/constants";
import { encodeFiltersHash } from "~/helpers/encode-filters-hash";
import { getFilterValuesForRequest } from "~/helpers/get-filter-values-for-request";
import { pushHistoryState } from "~/helpers/history";
import { Nullable } from "~/types/general.types";
import { IHashFilterParams } from "~/types/rbp-request-handler";

const updateHashAndPreservePageScrollPos = (hash: string) => {
  // The solution is to remove empty hash with # from url
  // or prevent empty hash to be added if there is no hash in url
  if (!hash || hash === "#") {
    if (location.hash) {
      pushHistoryState(location.pathname + location.search, {
        title: document.title,
      });
    }
    return;
  }

  if (hash?.startsWith("#")) {
    pushHistoryState(location.pathname + location.search + hash);
    return;
  }

  /* eslint-disable no-restricted-globals */
  const topPos =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;

  const leftPos =
    window.pageXOffset ||
    document.documentElement.scrollLeft ||
    document.body.scrollLeft ||
    0;

  location.hash = hash;

  document.documentElement.scrollTop = topPos;
  document.documentElement.scrollLeft = leftPos;
  /* eslint-enable */
};

export const updateUrlHash: (props: IHashFilterParams) => void = ({
  activeSortingParam = "",
  appliedFilters = null,
  isShopFilter = false,
  selectedStoreId = "",
  productType,
  config: {
    getMoreItems,
    variables: {
      locale = "en-GB",
      slug,
      shouldConcat = false,
      start = 0,
      rows = DEFAULT_PAGE_SIZE,
      efq,
      brUid2,
      brRefUrl,
    },
  },
}) => {
  const hash = encodeFiltersHash(
    activeSortingParam,
    appliedFilters,
    isShopFilter,
    productType,
  );

  const isRangedStoresFacet = isStoreOnlyDropdownQuery(efq);

  updateHashAndPreservePageScrollPos(hash);
  getMoreItems({
    variables: {
      start,
      rows,
      locale,
      slug,
      efq,
      fq:
        appliedFilters || isShopFilter !== null
          ? getFilterValuesForRequest(
              appliedFilters,
              isShopFilter,
              selectedStoreId,
              isRangedStoresFacet,
            )
          : null,
      shouldConcat,
      sort: activeSortingParam,
      brUid2,
      brRefUrl,
    },
  });
};

export const mappedFacetsRangesForFilter = (
  facet: Nullable<Nullable<WidgetFacetRange>[]>,
): Filters => {
  const facetRangeFilters = {} as {
    [key: string]: Nullable<Nullable<WidgetFacetRangeValue>[]> | undefined;
  };
  facet?.forEach((el) => {
    if (el?.key) {
      facetRangeFilters[el?.key] = el.value;
    }
  });
  return facetRangeFilters;
};
